<template>
  <data-list
    ref="dataList"
    class="content md"
    url="/admin/record-fire-fight"
    entity-name="器材养护记录"
    hide-action
    :action="action"
    :columns="columns"
    :modal-width="640"
    :modal-form="{
      layout: 'horizontal',
      labelAlign: 'left',
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    }"
    :search-key-type="searchKeyType"
  >
    <template v-slot:title="{ total }">
      <span style="margin-right: 12px">{{ title }}</span>
      <span>共{{ total }}条记录</span>
    </template>
    <template v-slot:query="{ form }">
      <a-form-model-item label="提交时间">
        <a-range-picker
          v-model="form.create_time"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          allow-clear
          @change="updateList"
          class="range-picker date"
        />
      </a-form-model-item>
      <a-form-model-item label="养护人">
        <a-input-search v-model="form.maintain_name" placeholder="输入养护人查询" allow-clear></a-input-search>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
import { getKeyTitle } from "@/common/js/tool";
import { typeOptions } from "@/common/constant/equipment";

export default {
  name: "Equipment",
  data() {
    return {
      columns: [
        { title: "提交时间", dataIndex: "create_time" },
        { title: "养护人", dataIndex: "maintain_name" },
        { title: "养护日期", dataIndex: "date" },
        {
          title: "状态",
          dataIndex: "status",
          customRender: (text) => <span>{getKeyTitle(typeOptions, text)}</span>,
        },
        { title: "异常原因", dataIndex: "reason" },
      ],
      searchKeyType: {
        create_time: (form, key) => {
          let res = "";
          const value = form[key];
          if (value?.length === 2) {
            res = `&filter[create_time][gte]=${value[0]} 00:00:00&&filter[create_time][lte]=${value[1]} 23:59:59`;
          }
          return res;
        },
        maintain_name: 1,
      },
      equipment: null,
      title: "",
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    action() {
      return this.$route.meta.action;
    },
  },
  watch: {
    id: {
      handler() {
        this.getEquipment();
      },
      immediate: true,
    },
  },
  methods: {
    getEquipment() {
      this.$axios(`/admin/fire-fight-equipment/${this.id}`).then((res) => {
        this.equipment = res;
        this.title = `${getKeyTitle(typeOptions, res.type)}${res.equipment_num}`;
      });
    },
    updateList() {
      this.$refs.dataList.updateList();
    },
  },
};
</script>

<style lang="less" scoped></style>
